import React from 'react'
import { TextField } from '@material-ui/core'

export const InputBase = ({
  classes,
  input,
  label,
  meta: { touched, error },
  helperText,
  ...custom
}) => {
  const errorText = Boolean(touched && error) 
    ? <span className={classes.helperText}>{error}</span>
    : Boolean(touched && helperText)
      ? <span className={classes.helperText}>{helperText}</span>
      : null

  return (
    <TextField
      label={label}
      error={Boolean(touched && error)}
      helperText={errorText}
      {...input}
      {...custom}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/Input/Input.js